module.exports = {"341021100":"徽城镇","341021101":"深渡镇","341021102":"北岸镇","341021103":"富堨镇","341021104":"郑村镇","341021105":"桂林镇","341021106":"许村镇","341021107":"溪头镇","341021108":"杞梓里镇","341021109":"霞坑镇","341021110":"岔口镇","341021111":"街口镇","341021112":"王村镇","341021113":"雄村镇","341021114":"三阳镇","341021200":"坑口乡","341021202":"上丰乡","341021203":"昌溪乡","341021204":"武阳乡","341021206":"金川乡","341021207":"小川乡","341021208":"新溪口乡","341021209":"璜田乡","341021210":"长陔乡","341021211":"森村乡","341021212":"绍濂乡","341021213":"石门乡","341021214":"狮石乡","341021400":"开发区类似乡级单位"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341021.json
// module id = 1017
// module chunks = 0